module.exports = __webpack_public_path__ + "img/no_wifi.4734f5fb.png";